<div (contextmenu)="onFieldLabelRightClick()">
  <ng-content></ng-content>
  <template #target></template>
</div>
